module.exports = __webpack_public_path__ + "components/country-flag/static/se-b6c007791a4c3febf601dea6a2190a53.svg";